// 校验经度
exports.longRG = longRG => longRG && /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/.test(longRG)
// 校验纬度
exports.latRG = latRG => latRG && /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/.test(latRG)
// 校验手机
exports.phone = phone => phone && /^[1,3][0-9][0-9]{9}$/.test(phone)